import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

import "../Styles/index.css";
import "./IntranetRedTheme.css";

import ArticulosUsuario from "./usuario/ArticulosUsuario";

export default function IntranetUsuarioArticulosPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const initialItem = location.state?.initialItem;

  return (
    <div className="intranet-red-theme">
      <ArticulosUsuario
        onVolver={() => navigate("/menu/intranet/usuario")}
        initialItem={initialItem}
      />
    </div>
  );
}
